import App from './ui/app.svelte';
import './global.css';

const app = new App({
    target: document.body
});